import { movies } from "@/mocks/movies";
import { reviews } from "@/mocks/reviews";
import usePageMeta from "@/hooks/usePageMeta";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestMovies from "@/pages/home/components/LatestMovies";
import EditorPicks from "@/pages/home/components/EditorPicks";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  usePageMeta({
    title: "爱的色放电影 - 高清电影介绍与影评聚合平台",
    description:
      "爱的色放电影为您提供详尽的电影介绍、剧情解析及观影指南，涵盖爱情题材及相关影视作品，助您深入了解每部电影的精彩内容。",
    keywords:
      "爱的色放电影,电影介绍,爱情电影,电影剧情,影视评论,电影资讯,电影推荐",
  });

  const featured = movies.filter((m) => m.featured);
  const latest = [...movies].sort((a, b) => b.year - a.year);
  const featuredReviews = reviews.filter((r) => r.featured);

  return (
    <>
      <HeroCarousel items={featured} />
      <CategoryGrid />
      <LatestMovies movies={latest} />
      <EditorPicks reviews={featuredReviews} movies={movies} />
      <SiteIntro />
    </>
  );
}